<script>
import appConfig from '@src/app.config.json'
import Axios from 'axios'
// import _ from 'lodash'
import Layout from '@layouts/main.vue'
import PlainCard from '@components/ui/cards/plain-card.vue'
import Card from '@components/ui/cards/data-center-card.vue'
import Skeleton from '@components/_base-skeleton.vue'
// import { forEach } from 'axios/lib/utils'

export default {
  page: {
    title: 'Search',
    meta: [{ name: 'description', content: 'The Search page.' }],
  },
  components: {
    Layout,
    PlainCard,
    Card,
    Skeleton,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    excerpt: function(text, limit) {
      return text
        .split(/\s+/)
        .slice(0, limit)
        .join(' ')
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
  },
  data() {
    return {
      filterCategories: [], // Must be an array reference!
      filterOptions: [
        { text: 'Legal Analysis', value: 'legal-analysis' },
        { text: 'Laws and Regulations', value: 'laws-and-regulations' },
        {
          text: 'International Conventions',
          value: 'international-conventions',
        },
        { text: 'Court Decisions', value: 'court-decisions' },
        { text: 'News', value: 'news' },
        { text: 'Academic Journals', value: 'academic-journals' },
        { text: 'Infographics', value: 'infographics' },
        { text: 'Directory', value: 'directories' },
        { text: 'Glossary', value: 'glossary' },
        { text: 'FAQ', value: 'faq' },
      ],
      activePage: 'all',
      pages: [],
      /*
       * each empty pages
       */
      // news
      News: [],
      // data center
      DataCenter: [],
      selectedDataCenter: [],
      CATFilterSelected: [],
      CATFilterOptions: [
        { text: 'Laws and Regulation', value: 'laws-and-regulation' },
        { text: 'Court Decisions', value: 'court-decisions' },
        {
          text: 'International Conventions',
          value: 'international-conventions',
        },
      ],
      LPFilterSelected: [],
      LPFilterOptions: [
        { text: 'Mahkamah Agung', value: 'Mahkamah Agung' },
        { text: 'Peradilan Umum', value: 'Peradilan Umum' },
        { text: 'Peradilan Agama', value: 'Peradilan Agama' },
        { text: 'Peradilan Militer', value: 'Peradilan Militer' },
        {
          text: 'Peradilan Tata Usaha Negara',
          value: 'Peradilan Tata Usaha Negara',
        },
        { text: 'Pengadilan Pajak', value: 'Pengadilan Pajak' },
      ],
      TPFilterSelected: [],
      TPFilterOptions: [
        { text: '2020', value: '2020' },
        { text: '2019', value: '2019' },
        { text: '2018', value: '2018' },
      ],
      StatusFilterSelected: [],
      StatusFilterOptions: [
        { text: 'Berkekuatan Hukum Tetap', value: 'Berkekuatan Hukum Tetap' },
        { text: 'Belum Berkekuatan Hukum', value: 'Belum Berkekuatan Hukum' },
      ],
      /**
       * Kebutuhan SEARCH PAGE
       */
      klasters:
        'legal-analysis,news,academic-journals,infographics,faq,directories,glossaries,laws-and-regulations,court-decisions,international-conventions',
      query: this.$route.query.q ? this.$route.query.q : '',
      klaster: this.$route.query.klaster ? this.$route.query.klaster : '',
      allData: null,
      // loading state
      loadOpacity: false,
      isLoading: true,
      pageName: 'search',
      scaleCol: false,
      isNotFound: false,
      isNullQuery: false,
      /** filters */
      filterSelected: [],
      filters: null,
      filterKlaster: null,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
    }
  },
  watch: {
    CATFilterSelected(newVal, oldVal) {
      // reset data center
      this.DataCenter = []
      // then add the new content
      this.getDataCenter(this.CATFilterSelected)
    },
    filterSelected: function(newVal, oldVal) {
      var taxo = (taxo) => {
        let data = ''
        const type = newVal.map((key) => {
          const dataMap = key.toString().split('|')
          return JSON.parse(`{"${dataMap[1]}":"${dataMap[0]}"}`)
        })
        var slugs = taxo.toString().split(',')
        data += '{ "taxonomy": {'
        // hold the array
        var holder = []
        /** then loop type we have been defined top */
        type.forEach((el, index) => {
          for (var i in el) {
            // if type[key] is in slugs
            if (slugs.includes(i)) {
              // then we add to holder
              if (holder[i] === undefined) {
                holder[i] = el[i] + ','
              } else {
                holder[i] += el[i] + ','
              }
            }
          }
        })

        /**
         * Then loop to get KEY and VALUE as we needed
         * ex: "jenis-institusi:badan institusi"
         */
        for (var i in holder) {
          data += `"${i}":"${holder[i]}"`
        }

        data += '}}'
        return JSON.parse(data.replaceAll('""', '","'))
      }
      /** loop the filter and get each slugs */
      const slugs = this.filterKlaster
        .map((key) => {
          return key.slug
        })
        .join(',')
      this.getSearchData(this.activePage.replaceAll(' ', '-'), taxo([slugs]))
    },
    filterCategories: function(newVal, oldVal) {
      var klasterObj = JSON.stringify(newVal)
      // var obj = { first: 'someVal', second: 'otherVal' }
      var klaster = klasterObj
        .substring(1, klasterObj.length - 1)
        .replaceAll('"', '')
      if (klaster) {
        this.getSearchData(klaster)
      } else {
        this.getSearchData(this.klasters)
      }
    },
  },
  mounted() {
    var pages = this.klasters.split(',')
    this.pages = pages
    /** check if it has search query param or not */
    if (this.query && this.klaster === '') {
      this.getSearchData(this.klasters)
    } else if (this.query && this.klaster !== '') {
      let klaster = ''
      switch (this.klaster) {
        case 'infografik':
        case 'infographic':
          klaster = 'infographics'
          break
        case 'direktori':
        case 'directory':
          klaster = 'directories'
          break
        case 'pusat-data':
        case 'data-center':
        case 'data-center-single':
          klaster =
            'laws-and-regulations,court-decisions,international-conventions'
          break
        case 'glosarium':
        case 'glossary':
          klaster = 'glossary'
          break
        case 'analisis-legal':
        case 'legal-analysis-single':
        case 'legal-analysis':
          klaster = 'legal-analysis'
          break
        case 'jurnal-akademik':
        case 'academic-journal':
        case 'academic-journal-single':
          klaster = 'academic-journals'
          break
        case 'artikel':
        case 'news-single':
          klaster = 'news'
          break
        default:
          klaster = this.klaster
          break
      }
      this.filterCategories = klaster.split(',')
      this.getSearchData(klaster)
    } else {
      this.isLoading = false
      this.isNullQuery = true
    }
  },
  methods: {
    activeTab: function(page) {
      // console.log(page)
      this.filters = null
      this.activePage = page
      var pages = this.klasters.split(',')
      if (this.activePage === 'all') {
        this.getSearchData(this.klasters)
      } else {
        pages.forEach((el) => {
          if (page.replaceAll(' ', '-') === el) {
            this.getSearchData(el)
          }
        })
      }
    },
    /**
     * Get Search Data Function
     * @param klaster: Separate using ,
     */
    getSearchData: function(klaster, param = {}) {
      // console.log(klaster)
      this.isNotFound = false
      this.loadOpacity = true
      /** define ANY API prequisite */
      var params = {
        klaster_slug: klaster,
        simple: true,
        // lang: this.lang,
        // taxonomy_show: false,
        keyword: this.query,
      }
      /** loop param then push to params */
      if (Object.keys(param).length > 0) {
        Object.keys(param).forEach((each) => {
          // attribute[tanggal_ditetapkan][]
          params[each] = param[each]
        })
      }
      /** params need to encoded from object to url params */
      var attr = ``
      params = Object.keys(params)
        .map(function(key) {
          if (key === 'taxonomy' && Object.keys(params).length > 0) {
            // first loop the 'params'
            Object.keys(params[key]).forEach((each1) => {
              attr += `taxonomy[${each1}]=${params[key][each1]}`
              attr += '&'
            })

            return attr.slice(0, -1)
          } else {
            return key + '=' + params[key]
          }
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-search?${params}`
      // console.log(endpoint)
      // console.log(endpoint.slice(0, -1))
      // get the news
      Axios.get(endpoint.slice(0, -1), getOptions).then((response) => {
        const data = response.data.data
        console.log(data)
        this.loadOpacity = false
        // after successfull response, we should then update the menuItems on data() above
        if (data) {
          this.allData = data
          this.isLoading = false
          this.isNotFound = false
        } else {
          this.isLoading = false
          this.allData = null
          this.isNotFound = true
        }
        if (this.filters === null) {
          this.filters = response.data.taxonomy
        }
        // console.log(this.filters)
        if (
          this.filters !== undefined &&
          this.activePage.replaceAll(' ', '-') in this.filters
        ) {
          if (this.activePage === 'all') {
            this.scaleCol = false
          } else {
            this.scaleCol = false
          }
          this.filterKlaster = this.filters[
            this.activePage.replaceAll(' ', '-')
          ]
        } else {
          if (this.activePage === 'all') {
            this.scaleCol = false
          } else {
            this.scaleCol = true
          }
          this.filterKlaster = null
        }
      })
    },
    toFilter: function(array, type = null) {
      if (Array.isArray(array) && array !== 'undefined') {
        var res = []
        array.forEach((el, index) => {
          var data = [
            {
              text: el.title,
              value: el.ID + '|' + type,
            },
          ]
          res.unshift(...data)
        })
        return res
      }
    },
    findSingle: function(klaster, slug) {
      switch (klaster) {
        case 'infographics':
          klaster = 'infographic'
          break
        case 'academic-journals':
          klaster = 'academic-journal'
          break
        case 'glossaries':
        case 'glossary':
          klaster = 'glossary'
          return klaster
        case 'laws-and-regulations' ||
          'court-decisions' ||
          'international-conventions':
          klaster = `/data-center/${klaster}`
          break
        default:
          break
      }
      if (klaster === 'faq') {
        return klaster
      }
      return `${klaster}/${slug}`
    },
  },
}
</script>

<template>
  <Skeleton
    v-if="isLoading === true"
    :type="pageName === 'default' ? 'default' : pageName"
  ></Skeleton>
  <Layout v-else margin="2rem auto">
    <b-container>
      <b-row>
        <b-col cols="12" class="mb-4">
          <h1 class="text-primary" bold
            >Search Results{{ query ? `: ${query}` : '' }}</h1
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="lg-3">
          <div v-if="activePage !== 'all'">
            <div v-for="(filter, indx) in filterKlaster" :key="indx">
              <PlainCard
                :header-border="true"
                :title="filter.title"
                class="mb-3"
              >
                <b-form-group class="mx-2">
                  <b-form-checkbox-group
                    v-model="filterSelected"
                    :options="toFilter(filter.data, filter.slug)"
                    name="categories"
                    stacked
                    :class="$style.filterCategories"
                  ></b-form-checkbox-group>
                </b-form-group>
              </PlainCard>
            </div>
          </div>
          <PlainCard
            v-show="activePage === 'all'"
            :header-border="true"
            title="Filter Categories"
          >
            <b-form-group class="mx-2">
              <b-form-checkbox-group
                v-model="filterCategories"
                :options="filterOptions"
                name="categories"
                stacked
                :class="$style.filterCategories"
              ></b-form-checkbox-group>
            </b-form-group>
          </PlainCard>
        </b-col>

        <b-col :cols="scaleCol ? 'lg-12' : 'lg-9'">
          <div :class="$style.searchContainer">
            <b-nav :class="$style.searchHeader">
              <b-nav-item
                :class="[activePage === 'all' ? $style.active : '']"
                @click="activeTab('all')"
                >All</b-nav-item
              >
              <div
                v-for="(page, index) in pages"
                :key="index"
                style="display:contents"
              >
                <b-nav-item
                  :class="[
                    activePage === page.toLowerCase() ? $style.active : '',
                  ]"
                  @click="activeTab(page.toLowerCase())"
                  >{{ page.replaceAll('-', ' ') | capitalize }}</b-nav-item
                >
              </div>
            </b-nav>
            <div class="searchFilter"> </div>
            <div v-if="isNotFound">
              <b-row :class="$style.errorHandler">
                <b-col cols="12">
                  <p>
                    {{ $t('no_match_found') + ' ' + query }}
                  </p>
                  <a
                    v-show="activePage !== 'all'"
                    class="text-primary"
                    pointer
                    @click="activeTab('all')"
                    >tampilkan semua data</a
                  >
                </b-col>
              </b-row>
            </div>
            <div v-if="isNullQuery">
              <b-row :class="$style.errorHandler">
                <b-col cols="12">
                  <h1 :style="{ fontSize: '5em' }">:(</h1>
                  <p>
                    {{
                      `Cobalah untuk mengetik kata kunci yang ingin anda cari diatas`
                    }}
                  </p>
                  <a
                    v-show="activePage !== 'all'"
                    class="text-primary"
                    pointer
                    @click="activeTab('all')"
                    >tampilkan semua data</a
                  >
                </b-col>
              </b-row>
            </div>
            <div v-else :class="$style.searchResults">
              <div v-show="activePage">
                <div v-for="(data, index) in allData" :key="index">
                  <Card
                    :title="data.title"
                    heading-tag="a"
                    :category="$t(data.klaster_title)"
                    :bold-category="true"
                    :class="loadOpacity ? 'isLoading' : ''"
                    :url="findSingle(data.klaster_slug, data.slug)"
                  >
                    <div v-if="data.caption">{{
                      data.caption | plainText
                    }}</div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.errorHandler {
  display: flex;
  align-items: center;
  min-height: 25vh;
}
.filterCategories {
  [class~='custom-checkbox'] {
    margin: 0.5rem 0;
  }
}
.searchContainer {
  .searchHeader {
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 2px solid $gray;
    [class~='nav-item'] {
      [class~='nav-link'] {
        padding: 0.5rem;
        color: $gray;
      }
      &.active {
        [class~='nav-link'] {
          position: relative;
          color: $orange;
          &::after {
            position: absolute;
            bottom: 0.25rem;
            left: 50%;
            width: calc(100% - 1rem);
            height: 2px;
            content: '';
            background-color: #f6921e;
            transform: translate(-50%);
          }
        }
      }
    }
  }
  .searchResults {
    .headerInfo {
      padding-left: 0;
      li {
        font-weight: 500;
        color: rgba(0, 0, 0, 0.5);
        list-style: none;
      }
    }
  }
}
</style>
